export default {"src":"/_next/static/media/instagram.8cd8da6d.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};